import NotificationsBell from './NotificationsBell'

export default NotificationsBell

export * from './NotificationsBell'
